import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router'
import {LoadingComponent} from './shared/components/loading/loading.component';
import {ToastModule} from 'primeng/toast';
import {MessageModule} from 'primeng/message';
import {CustomerService} from './core/services/customer/customer.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, LoadingComponent, ToastModule, MessageModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private _customerService: CustomerService = inject(CustomerService);

  public ngOnInit(): void {
    this._customerService.loadCustomer();
  }
}
